import { Button as ButtonPrimitive } from '@base-ui/react/button';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const buttonVariants = cva(
  "group/button inline-flex shrink-0 items-center justify-center rounded-2xl border border-transparent bg-clip-padding text-sm font-medium whitespace-nowrap transition-all outline-none select-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/30 active:not-aria-[haspopup]:translate-y-px disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  { variants: { variant: {
    default: 'bg-primary text-primary-foreground hover:bg-primary/80',
    outline: 'border-border bg-card hover:bg-muted hover:text-foreground aria-expanded:bg-muted',
    secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
    ghost: 'hover:bg-muted hover:text-foreground aria-expanded:bg-muted',
    destructive: 'bg-destructive/10 text-destructive hover:bg-destructive/20 focus-visible:ring-destructive/20',
    link: 'text-primary underline-offset-4 hover:underline',
  }, size: {
    default: 'h-8 gap-1.5 px-3', xs: 'h-6 gap-1 px-2.5 text-xs', sm: 'h-7 gap-1 px-3', lg: 'h-9 gap-1.5 px-4', icon: 'size-8', 'icon-xs': 'size-6', 'icon-sm': 'size-7', 'icon-lg': 'size-9',
  } }, defaultVariants: { variant: 'default', size: 'default' } }
);

function Button({ className, variant = 'default', size = 'default', ...props }: ButtonPrimitive.Props & VariantProps<typeof buttonVariants>) {
  return <ButtonPrimitive data-slot="button" className={cn(buttonVariants({ variant, size, className }))} {...props} />;
}

export { Button, buttonVariants };
